(() => {
  'use strict';
  const root = document.querySelector('[data-hebeso-raspberry]');
  if (!root || root.dataset.initialized) return;
  const config=JSON.parse(root.querySelector('#hebeso-raspberry-data').textContent);
  root.dataset.initialized='true';
  const pricing = window.HebesoCartPricing;
  if (!pricing) return;
  const formatPriceText = (key, values = {}) => pricing.strings[key].replace(/\{(\w+)\}/g, (match, name) => String(values[name] ?? match));
  const canSubmit = q => q.count > 0 && (Boolean(bundleEdit) || q.eligibleCount >= 2);
  const stockGuard = window.HebesoStockGuard?.create(config.stockStrings);
  const stockText = (key, values) => config.stockStrings[key].replace(/\{(\w+)\}/g, (match, name) => String(values[name] ?? match));
  const $=selector=>root.querySelector(selector);
  const $$=selector=>[...root.querySelectorAll(selector)];
  const euro=cents=>new Intl.NumberFormat('de-DE',{style:'currency',currency:config.currency||'EUR'}).format(cents/100);
  const products={};
  for(const item of config.catalog){
    const id=item.handle==='himbeersamenol-100'?'oil':item.handle==='naturliche-himbeersamenol-korperbutter-120ml'?'butter':item.handle==='himbeer-deocreme-60ml'?'deo':'v'+item.variantId;
    const volume=item.name.match(/(\d+)\s?ml/i);
    const category=/haar/i.test(item.name)?'hair':/peeling|butter|deo/i.test(item.name)?'body':/serum|reinigung/i.test(item.name)?'face':'oils';
    products[id]={...item,id,category,volume:volume?Number(volume[1]):0,size:volume?volume[1]+' ml':(item.variantTitle==='Default Title'?'':item.variantTitle)};
  }
  let primary = config.variants.find(item => item.variantId === config.currentId) || config.variants[0];
  let primaryId = Object.keys(products).find(id => products[id].variantId === primary.variantId);
  function productQuote(count) {
    if (!Number.isInteger(count) || count < 1 || count > 3) throw new Error('Bitte eine gültige Menge wählen.');
    return pricing.quote([{...primary, quantity:count}], serverCart);
  }
  function productSize() {
    const match = primary.variantTitle.match(/(\d+)\s?ml/i);
    const volume = match ? Number(match[1]) : config.volume;
    return {volume, label:volume ? volume+' ml' : primary.variantTitle === 'Default Title' ? '' : primary.variantTitle};
  }
  let quantity=1;
  let bundle=Object.fromEntries(Object.keys(products).map(id=>[id,location.hash!=='#bundle-empty'&&id===primaryId&&primary.available?1:0]));
  let catalogCategory='all';
  let bundleEdit=null;
  let galleryIndex=0;
  const gallery=config.gallery;
  const html=value=>String(value).replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const categories = { all: 'Alle', oils: 'Öle', body: 'Körperpflege', face: 'Gesichtspflege', hair: 'Haarpflege' };
  const normalize = value => String(value).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').replace(/ß/g, 'ss').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  function listProducts({ search = '', category = 'all', available = false, sort = 'default' } = {}) {
    const words = normalize(search).trim().split(/\s+/).filter(Boolean);
    const items = Object.entries(products).filter(([id, p]) => {
      const haystack = normalize(`${p.name} ${p.size} ${categories[p.category]}`);
      return (category === 'all' || p.category === category) && (!available || p.available) && words.every(word => haystack.includes(word));
    });
    if (sort === 'price-low') items.sort((a, b) => a[1].price - b[1].price);
    else if (sort === 'price-high') items.sort((a, b) => b[1].price - a[1].price);
    else if (sort === 'name') items.sort((a, b) => a[1].name.localeCompare(b[1].name, 'de'));
    return items.map(([id]) => id);
  }
  function rateFor(count) { return pricing.tier(count); }
  function quote(selection, mode = 'bundle') {
    if (!selection || typeof selection !== 'object' || Array.isArray(selection)) throw new Error('Ungültige Auswahl.');
    let original = 0, count = 0;
    for (const [id, quantity] of Object.entries(selection)) {
      if (!Object.hasOwn(products, id) || !Number.isInteger(quantity) || quantity < 0 || quantity > 99) throw new Error('Ungültiges Produkt oder ungültige Menge.');
      if (quantity > 0 && !products[id].available) throw new Error(stockText('unavailable', {name:products[id].name}));
      count += quantity;
      original += products[id].price * quantity;
    }
    if (mode === 'product' && (Object.keys(selection).some(id => id !== primaryId))) throw new Error('Ungültige Produktauswahl.');
    return pricing.quote(Object.entries(selection).filter(([,quantity]) => quantity > 0)
      .map(([id,quantity]) => ({...products[id], quantity})), serverCart, mode === 'bundle' ? bundleEdit?.key : null);
  }
  const routines = {use: config.application || '', notes: config.notes || ''};
  function announce(message) { $('#notification').textContent = message; }
  function setQuantity(next) {
    errorMessage('');
    const q = productQuote(next), size = productSize();
    quantity = next;
    $$('input[name=quantity]').forEach(input => { input.checked = Number(input.value) === quantity; });
    $('#product-price').textContent = euro(q.total);
    $('#product-previous').hidden = q.saving === 0;
    $('#product-previous').textContent = euro(q.original);
    $('#volume-label').textContent = size.label ? (quantity === 1 ? size.label : `${quantity} × ${size.label}`) : '';
    $('#unit-price').textContent = primary.unitReference && primary.unitPrice
      ? `${euro(Math.round(primary.unitPrice * (100-q.rate)/100))} / ${primary.unitReference}`
      : size.volume ? `${euro(Math.round(q.total * 1000 / (quantity*size.volume)))} / l` : '';
    $('.button-price').textContent = euro(q.total);
    $('#product-delivered').textContent = euro(q.delivered);
    $('[data-hebeso-price-context]').textContent = formatPriceText('context', {existing:q.existingCount,count:q.eligibleCount,rate:q.cartRate});
    $('#shipping-description').textContent = q.shipping ? config.strings.shipping : config.strings.freeShipping;
    announce(`${quantity} ${config.strings.piece}, ${euro(q.total)}.`);
    return q;
  }
  function renderPrimary() {
    syncSetLinks();
    $('.quantity-field').disabled = !primary.available;
    $$('.add-product').forEach(button => {button.disabled=!primary.available;button.querySelector('[data-add-label]').textContent=primary.available?config.strings.add:config.strings.soldOut;});
    $('#quantity-caption').textContent=primaryId?config.strings.quantityDiscount:config.strings.quantityPlain;
    $$('.quantity-card').forEach(card => {
      const count=Number(card.querySelector('input').value), q=productQuote(count);
      card.querySelector('[data-quantity-price]').textContent=euro(q.total);
      card.querySelector('[data-quantity-unit]').textContent=euro(Math.round(q.total/count))+' / '+config.strings.piece;
      const badge=card.querySelector('.quantity-saving');badge.hidden=!q.rate;badge.textContent='−'+q.rate+' %';
    });
    setQuantity(quantity);
  }
  function selectImage(index) {
    if (!gallery.length) return;
    galleryIndex = ((index % gallery.length) + gallery.length) % gallery.length;
    const img = gallery[galleryIndex];
    $('#main-image').src = img.source;
    $('#main-image').alt = img.alt;
    $('#lightbox-image').src = img.source;
    $('#lightbox-image').alt = img.alt;
    $('.image-counter').textContent = `0${galleryIndex + 1} / ${String(gallery.length).padStart(2,'0')}`;
    $('#lightbox-count').textContent = `${galleryIndex + 1} / ${gallery.length}`;
    $$('.thumbnail').forEach((button, i) => {
      button.classList.toggle('selected', galleryIndex === i);
      button.setAttribute('aria-pressed', String(galleryIndex === i));
    });
  }
  function showDialog(dialog) { if (!dialog.open) dialog.showModal(); }
  function renderBundle() {
    const q = quote(bundle);
    for (const card of $$('[data-bundle-card]')) {
      const id = card.dataset.bundleCard, count = bundle[id];
      card.classList.toggle('in-set', count > 0);
      card.querySelector('output').textContent = String(count);
      card.querySelector('[data-change="-1"]').disabled = count === 0;
      card.querySelector('[data-change="1"]').disabled = count >= 99 || !products[id].available;
    }
    $('#bundle-selection').replaceChildren();
    for (const [id, count] of Object.entries(bundle)) {
      if (!count) continue;
      const row = document.createElement('p'); row.className = 'selection-row';
      const name = document.createElement('span'); name.textContent = `${count} × ${products[id].name}`;
      const amount = document.createElement('span'); amount.textContent = euro(count * products[id].price);
      row.append(name, amount); $('#bundle-selection').append(row);
    }
    if (q.count === 0) $('#bundle-selection').textContent = 'Wähle deine Favoriten aus.';
    $('#bundle-original').textContent = euro(q.original);
    $('#bundle-discount-label').textContent = q.rate ? `Dein Set-Rabatt (${q.rate} %)` : 'Dein Set-Rabatt';
    $('#bundle-saving').textContent = q.saving ? `−${euro(q.saving)}` : euro(0);
    $('#bundle-total').textContent = euro(q.total);
    const hints = ['Wähle mindestens 2 Produkte für 5 % Rabatt.', 'Noch ein Produkt für 5 % Rabatt.', '5 % gespart. Ab 3 Produkten erhältst du 9 %.', '9 % gespart. Ab 4 Produkten erhältst du 12 %.', '12 % gespart. Ab 5 Produkten erhältst du 15 %.'];
    $('#bundle-hint').textContent = hints[q.eligibleCount] || pricing.strings.cart_max;
    $('#add-bundle').disabled = !canSubmit(q);
    $('#add-bundle').textContent = canSubmit(q) ? `Set in den Warenkorb · ${euro(q.total)}` : 'Mindestens 2 Produkte wählen';
    $$('.discount-steps>div').forEach(step => { const n = Number(step.dataset.tier); step.classList.toggle('achieved', q.eligibleCount >= n); step.classList.toggle('current', Math.min(q.eligibleCount, 5) === n); });
    renderCatalogSelection();
    renderBuilderSummary(q);
    return q;
  }
  function createBundleCards() {
    const container = $('#bundle-products');
    const recommended = (config.suggested || []).map(handle => Object.keys(products).find(id => products[id].handle===handle));
    const picks = [...new Set([primaryId,...recommended,...Object.keys(products)].filter(id=>id && products[id]?.available))].slice(0,3);
    for (const id of picks) {
      const p = products[id];
      if (!p) continue;
      const card = document.createElement('article'); card.className = 'bundle-card'; card.dataset.bundleCard = id;
      card.innerHTML = `<img src="${html(p.image)}" alt="${html(p.name)}" width="95" height="95" loading="lazy"><div class="bundle-card-info"><h3>${html(p.name)}</h3><p>${html(p.size)}</p><strong>${euro(p.price)}</strong></div><div class="stepper"><button type="button" data-change="-1" aria-label="${html(p.name)}: Menge verringern">−</button><output aria-label="${html(p.name)}: gewählte Menge">0</output><button type="button" data-change="1" aria-label="${html(p.name)}: Menge erhöhen">+</button></div>`;
      card.querySelectorAll('[data-change]').forEach(button => button.addEventListener('click', () => {
        const next = bundle[id] + Number(button.dataset.change);
        if (next < 0 || next > 99) return;
        setBundleQuantity(id, next);
      }));
      container.append(card);
    }
  }
  function setBundleQuantity(id, next) {
    errorMessage('');
    const updated = { ...bundle, [id]: next };
    quote(updated);
    const active = document.activeElement;
    const focusId = active?.dataset?.productId;
    const focusAction = active?.dataset?.action;
    const fromSummary = !!active?.closest('.builder-selected');
    const wasAdd = active?.classList?.contains('catalog-add');
    bundle = updated;
    const q = renderBundle();
    if (fromSummary) {
      const replacement = $(`#builder-selected [data-product-id="${focusId}"][data-action="${focusAction}"]`);
      (replacement && !replacement.disabled ? replacement : $('#builder-selected button') || $('#catalog-search')).focus({ preventScroll: true });
    } else if (wasAdd) {
      $(`#catalog-grid [data-catalog-id="${id}"] [data-action="plus"]`).focus({ preventScroll: true });
    } else if (focusAction === 'minus' && next === 0) {
      $(`#catalog-grid [data-catalog-id="${id}"] .catalog-add`)?.focus({ preventScroll: true });
    }
    announce(`${q.count} Produkte im Set. Preis ${euro(q.total)}. Rabatt ${q.rate} Prozent.`);
    return q;
  }
  function createCatalog() {
    $$('.catalog-total-count').forEach(element => { element.textContent = String(Object.keys(products).length); });
    for (const [id, label] of Object.entries(categories)) {
      const button = document.createElement('button'); button.type = 'button'; button.dataset.category = id;
      button.setAttribute('aria-pressed', String(id === 'all'));
      button.innerHTML = `${html(label)} <span></span>`;
      button.addEventListener('click', () => { catalogCategory = id; applyCatalogFilters(); });
      $('#catalog-categories').append(button);
    }
    for (const [id, p] of Object.entries(products)) {
      const card = document.createElement('article'); card.className = 'catalog-card'; card.dataset.catalogId = id;
      const pricePerLiter = p.volume ? `${euro(Math.round(p.price * 1000 / p.volume))} / l` : '';
      card.innerHTML = `<div class="catalog-photo"><img src="${html(p.image)}" alt="${html(p.name)}" width="220" height="220" loading="lazy"><span class="catalog-selected-badge" hidden>✓ Im Set</span>${p.available ? '' : '<span class="catalog-unavailable-badge">Derzeit nicht verfügbar</span>'}</div><div class="catalog-info"><p class="catalog-category-label">${html(categories[p.category])} · ${html(p.size)}</p><h3>${html(p.name)}</h3><div class="catalog-price"><strong>${euro(p.price)}</strong><span>${pricePerLiter}</span></div><a class="catalog-detail" href="${html(p.source)}" target="_blank" rel="noopener" aria-label="${html(p.name)}: Produktdetails öffnen">Produktdetails</a><button class="catalog-add" type="button" data-product-id="${id}" data-action="plus" ${p.available ? '' : 'disabled'}>${p.available ? '+ Zum Set hinzufügen' : 'Nicht verfügbar'}</button><div class="catalog-quantity stepper" hidden><button type="button" data-product-id="${id}" data-action="minus" aria-label="${html(p.name)}: Menge verringern">−</button><output aria-label="${html(p.name)}: gewählte Menge">0</output><button type="button" data-product-id="${id}" data-action="plus" aria-label="${html(p.name)}: Menge erhöhen">+</button></div></div>`;
      $('#catalog-grid').append(card);
    }
    applyCatalogFilters();
  }
  function filterOptions() {
    return { search: $('#catalog-search').value, category: catalogCategory, available: $('#catalog-available').checked, sort: $('#catalog-sort').value };
  }
  function applyCatalogFilters() {
    const options = filterOptions(), result = listProducts(options), visible = new Set(result);
    $$('#catalog-grid .catalog-card').forEach(card => { card.hidden = !visible.has(card.dataset.catalogId); });
    result.forEach(id => { $('#catalog-grid').append($(`[data-catalog-id="${id}"]`)); });
    $$('#catalog-categories button').forEach(button => {
      const category = button.dataset.category;
      button.setAttribute('aria-pressed', String(catalogCategory === category));
      button.querySelector('span').textContent = String(listProducts({ ...options, category }).length);
    });
    $('#catalog-result-count').textContent = `${result.length} von ${Object.keys(products).length} Produkten`;
    $('#catalog-empty').hidden = result.length > 0;
    $('#catalog-grid').hidden = result.length === 0;
    return result;
  }
  function renderCatalogSelection() {
    $$('#catalog-grid .catalog-card').forEach(card => {
      const id = card.dataset.catalogId, count = bundle[id] || 0;
      card.classList.toggle('in-set', count > 0);
      card.querySelector('.catalog-selected-badge').hidden = count === 0;
      card.querySelector('.catalog-add').hidden = count > 0;
      card.querySelector('.catalog-quantity').hidden = count === 0;
      card.querySelector('output').textContent = String(count);
      card.querySelector('.catalog-quantity [data-action=plus]').disabled = count >= 99;
      card.querySelector('.catalog-quantity [data-action=minus]').disabled = count === 0;
    });
  }
  function renderSetProgress(q) {
    const words = config.setStrings;
    const format = (text, values) => text.replace(/\{(\w+)\}/g, (match, key) => String(values[key] ?? match));
    const next = [2, 3, 4, 5].find(tier => q.eligibleCount < tier);
    const remaining = next ? next - q.eligibleCount : 0;
    const message = next
      ? format(remaining === 1 ? words.next_one : words.next_many, {count:remaining,rate:rateFor(next, 'bundle')})
      : words.maximum;
    $('#set-next-tier').textContent = message;
    $('#set-current-saving').textContent = format(q.cartSaving ? words.saving : words.no_discount, {count:q.eligibleCount,saving:euro(q.cartSaving)});
    const bar = $('.set-progress-track');
    bar.setAttribute('aria-valuenow', String(Math.min(q.eligibleCount, 5)));
    bar.setAttribute('aria-valuetext', format(words.progress_value, {count:q.eligibleCount,rate:q.cartRate}));
    bar.querySelector('span').style.width = `${Math.min(q.eligibleCount / 5, 1) * 100}%`;
    $$('.set-progress-steps [data-tier]').forEach(step => {
      const tier = Number(step.dataset.tier), current = tier === Math.min(q.eligibleCount, 5);
      step.classList.toggle('achieved', q.eligibleCount >= tier);
      step.classList.toggle('current', current);
      step.classList.toggle('next', tier === next);
      if (current) step.setAttribute('aria-current', 'step'); else step.removeAttribute('aria-current');
    });
  }
  function renderBuilderSummary(q) {
    renderSetProgress(q);
    const preview = {subtotal:q.cartSubtotal, shipping:q.shipping, total:q.cartDelivered};
    const container = $('#builder-selected'), oldScroll = container.scrollTop;
    const fragments = [];
    for (const [id, count] of Object.entries(bundle)) {
      if (!count) continue;
      const p = products[id];
      fragments.push(`<article class="builder-selected-item"><img src="${html(p.image)}" alt="" width="48" height="54"><div><h4>${html(p.name)}</h4><p>${html(p.size)} · ${euro(count * p.price)}</p><div class="selected-controls"><div class="stepper"><button type="button" data-product-id="${id}" data-action="minus" aria-label="${html(p.name)}: Menge verringern">−</button><output aria-label="${html(p.name)}: gewählte Menge">${count}</output><button type="button" data-product-id="${id}" data-action="plus" aria-label="${html(p.name)}: Menge erhöhen" ${count >= 99 ? 'disabled' : ''}>+</button></div><button class="selected-remove" type="button" data-product-id="${id}" data-action="remove" aria-label="${html(p.name)} aus dem Set entfernen">Entfernen</button></div></div></article>`);
    }
    container.innerHTML = fragments.length ? fragments.join('') : '<p class="builder-empty-selection">Dein Set wartet auf deine Favoriten.</p>';
    container.scrollTop = oldScroll;
    $('#builder-count').textContent = String(q.count);
    $('#builder-count-word').textContent = q.count === 1 ? 'Produkt' : 'Produkte';
    $('#builder-original').textContent = euro(q.original);
    $('#builder-rate').textContent = q.rate ? `Dein Rabatt (${q.rate} %)` : 'Dein Rabatt';
    $('#builder-saving').textContent = q.saving ? `−${euro(q.saving)}` : euro(0);
    $('#builder-total').textContent = euro(q.total);
    $('#builder-other-items-row').hidden = q.otherTotal === 0;
    $('#builder-other-items').textContent = euro(preview.subtotal - q.total);
    $('#builder-shipping').textContent = !q.cartSubtotal ? '—' : preview.shipping ? euro(preview.shipping) : 'Kostenlos';
    $('#builder-delivered-label').textContent = pricing.strings.estimate;
    $('#builder-delivered').textContent = euro(preview.total);
    $('#builder-hint').textContent = $('#bundle-hint').textContent;
    $('#builder-mobile-count').textContent = String(q.count);
    $('#builder-mobile-total').textContent = euro(q.total);
    $('#builder-mobile-saving').textContent = q.rate ? `${q.rate} % Rabatt · ${euro(q.saving)} gespart` : `Noch ${Math.max(0, 2 - q.eligibleCount)} ${q.eligibleCount === 1 ? 'Produkt' : 'Produkte'} für Rabatt`;
    $$('.builder-discounts>span').forEach(step => { const tier = Number(step.dataset.tier); step.classList.toggle('achieved', q.eligibleCount >= tier); step.classList.toggle('current', Math.min(q.eligibleCount, 5) === tier); });
    $('#builder-title').textContent = bundleEdit ? config.setStrings.builder_edit_title : config.setStrings.builder_title;
    $('#builder-edit-note').hidden = !bundleEdit;
    $('#cancel-bundle-edit').hidden = !bundleEdit;
    $$('.builder-add').forEach(button => { button.disabled = !canSubmit(q); button.textContent = canSubmit(q) ? (bundleEdit ? 'Änderungen speichern' : 'Set in den Warenkorb') : 'Ab 2 Produkten'; });
  }
  function setPageUrl(source = 'product', editKey = '') {
    const url = new URL(config.setUrl || (config.root || '/') + 'pages/dein-set', location.origin);
    if (editKey) url.searchParams.set('edit_set', editKey);
    else if (source !== 'menu') {
      url.searchParams.set('product', root.dataset.productHandle);
      url.searchParams.set('variant', primary.variantId);
    }
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }
  function syncSetLinks() {
    $$('[data-hebeso-set-entry]').forEach(link => { link.href = setPageUrl(); });
  }
  async function openBuilder({ source = 'product' } = {}) {
    if (!busy) location.assign(setPageUrl(source, bundleEdit?.key));
  }
  function toggleBuilderSummary(force) {
    const open = typeof force === 'boolean' ? force : !$('#bundle-builder').classList.contains('summary-open');
    $('#bundle-builder').classList.toggle('summary-open', open);
    $('#toggle-builder-summary').setAttribute('aria-expanded', String(open));
    $('.builder-browser').inert = open && window.matchMedia('(max-width:760px)').matches;
  }
  let serverCart = pricing.getCart();
  let busy = false;
  const cartRoot = (config.root || '/').replace(/\/?$/, '/');
  const groupItems = (state, id) => state.items.filter(item => item.properties?._hebeso_set_id === id);
  const groupSignature = items => JSON.stringify(items.map(item => [item.variant_id, item.quantity, item.selling_plan_allocation?.selling_plan?.id || '', item.properties]).sort((a,b)=>a[0]-b[0]));
  const selectedStockEntries = selection => Object.entries(selection).filter(([,count]) => count > 0).map(([id,count]) => ({...products[id], quantity:count}));
  async function stockFailure(error, entries, cartBefore, editedGroup) {
    return stockGuard ? stockGuard.describeFailure(error, entries, cartBefore, editedGroup) : error.message;
  }
  function errorMessage(message) {
    $$('[data-hrp-error]').forEach(element => { element.textContent = message || ''; element.hidden = !message; });
    if (message) announce(message);
  }
  function setBusy(value) {
    busy = value;
    root.dataset.loading = String(value);
    root.setAttribute('aria-busy', String(value));
    if($('#hebeso-design-variant'))$('#hebeso-design-variant').disabled=value;
    $$('.add-product, #add-bundle, .builder-add, #cancel-bundle-edit').forEach(button => { button.disabled = value; });
    $('.quantity-field').disabled = value || !primary.available;
    $('.builder-body').inert = value;
    $$('.builder-head .close-dialog').forEach(button => { button.disabled = value; });
    document.querySelector('hebeso-cart')?.setBusy?.(value);
    if (!value) {
      renderBundle();
      $$('.add-product').forEach(button => { button.disabled = !primary.available; });
    }
  }
  async function cartRequest(endpoint, data) {
    const response = await fetch(cartRoot + endpoint, {
      method: data === undefined ? 'GET' : 'POST', credentials: 'same-origin',
      cache: 'no-store', headers: { Accept: 'application/json', ...(data === undefined ? {} : { 'Content-Type': 'application/json' }) },
      ...(data === undefined ? {} : { body: JSON.stringify(data) }), hebesoCartInternal: true
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) {
      const error = new Error(result.description || result.message || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
      error.status = result.status || response.status; error.endpoint = endpoint;
      throw error;
    }
    return result;
  }
  async function readCart() { serverCart = await pricing.refresh(); return serverCart; }
  function groupProperties(groupId, mode) {
    return { _hebeso_set_id:groupId, _hebeso_set_mode:mode };
  }
  async function refreshCartDiscounts() { return readCart(); }
  async function showNativeCart(message = '') {
    const element = document.querySelector('hebeso-cart');
    if (element?.open) {
      await element.open();
      if (message) element.error(message);
    } else location.assign(cartRoot + 'cart');
  }
  function verifyGroup(state, groupId, selection, expected) {
    const lines = groupItems(state, groupId);
    const actualCount = lines.reduce((sum, item) => sum + item.quantity, 0);
    const actualTotal = lines.reduce((sum, item) => sum + item.final_line_price, 0);
    if (actualCount !== expected.count || Object.entries(selection).some(([id,count]) => count !== lines.filter(line => line.variant_id === products[id].variantId).reduce((sum,line)=>sum+line.quantity,0))) {
      const changes = Object.entries(selection).map(([id,count]) => ({product:products[id], selected:count,
        actual:lines.filter(line => line.variant_id === products[id].variantId).reduce((sum,line) => sum + line.quantity, 0)}))
        .filter(item => item.selected !== item.actual);
      return config.stockStrings.changed_heading + '\n' + changes.map(item => stockText('changed_quantity', {name:item.product.name, actual:item.actual, selected:item.selected})).join('\n');
    }
    if (actualTotal > expected.total + 1) return 'Der Set-Rabatt konnte nicht wie angezeigt angewendet werden. Bitte prüfe den aktuellen Preis im Warenkorb, bevor du zur Kasse gehst.';
    return '';
  }
  async function editCartBundle(key) {
    if (!busy) location.assign(setPageUrl('menu', key));
  }
  async function finishBundleEdit(save = false) {
    if (!bundleEdit || busy) return;
    if (!save) {
      const previousSelection = bundleEdit.previousSelection;
      bundleEdit = null; bundle = previousSelection;
      renderBundle(); toggleBuilderSummary(false); $('#bundle-builder').close();
      await showNativeCart();
      announce('Bearbeitung abgebrochen. Dein Set ist unverändert.');
      return;
    }
    const edit = bundleEdit, selection = { ...bundle };
    let expected = quote(selection);
    if (!canSubmit(expected)) return;
    errorMessage(''); setBusy(true);
    let changed = false, warning = '', keepEditing = false, cartBefore;
    const entries = selectedStockEntries(selection);
    try {
      await readCart();
      if (groupSignature(groupItems(serverCart, edit.key)) !== edit.signature) throw new Error('Dein Warenkorb wurde zwischenzeitlich geändert. Bitte öffne das Set erneut.');
      cartBefore = serverCart;
      expected = quote(selection);
      if (stockGuard) await stockGuard.assertAvailable(entries, cartBefore, edit.key);
      const additions = [];
      for (const [id, count] of Object.entries(selection)) {
        const existing = groupItems(serverCart, edit.key).filter(item=>item.variant_id===products[id].variantId).reduce((sum,item)=>sum+item.quantity,0);
        if (count > existing) additions.push({ id: products[id].variantId, quantity: count-existing, properties: edit.properties });
      }
      if (additions.length) { await cartRequest('cart/add.js', { items: additions }); changed=true; }
      // Resolve each line again after every mutation: Shopify changes line keys when discounts change.
      for (const [id, count] of Object.entries(selection)) {
        await readCart();
        const line = groupItems(serverCart, edit.key).find(item=>item.variant_id===products[id].variantId);
        if (line && count < line.quantity) { await cartRequest('cart/change.js', { id: line.key, quantity: count }); changed=true; }
      }
      const state=await refreshCartDiscounts();
      warning=verifyGroup(state,edit.key,selection,expected);
      announce('Dein Set wurde aktualisiert.');
    } catch(error) {
      // An add can partially succeed even when Shopify returns 422.
      if (error.code !== 'HEBESO_STOCK') {
        try { changed = changed || groupSignature(groupItems(await readCart(), edit.key)) !== edit.signature; } catch {}
      }
      keepEditing = error.code === 'HEBESO_STOCK' && !changed;
      warning = await stockFailure(error, entries, cartBefore, edit.key);
      if (changed) warning += ' Einige Änderungen wurden bereits übernommen. Bitte prüfe den Warenkorb.';
      errorMessage(warning);
    } finally {
      if (keepEditing) {
        setBusy(false);
      } else {
        bundleEdit=null; bundle=edit.previousSelection;
        toggleBuilderSummary(false); $('#bundle-builder').close(); setBusy(false);
        await showNativeCart(warning);
      }
    }
  }
  function closeDialog(dialog) {
    if (busy) return;
    if (dialog === $('#bundle-builder') && bundleEdit) finishBundleEdit(false);
    else dialog.close();
  }
  async function addStandaloneProduct() {
    if (busy || !primary.available) return;
    errorMessage('');setBusy(true);
    let added=false, warning='', cartBefore;
    const entries = [{...primary, name:config.productName, source:config.productUrl, quantity}];
    const cartQuantity = state => (state?.items || []).filter(item => item.variant_id === primary.variantId).reduce((sum,item) => sum + item.quantity, 0);
    try {
      cartBefore = await readCart();
      if (stockGuard) await stockGuard.assertAvailable(entries, cartBefore);
      await cartRequest('cart/add.js',{items:[{id:primary.variantId,quantity}]});
      added=true;
      await readCart();
      announce('Deine Auswahl wurde zum Warenkorb hinzugefügt.');
    } catch(error) {
      if (cartBefore && error.code !== 'HEBESO_STOCK') {
        try { added = added || cartQuantity(await readCart()) > cartQuantity(cartBefore); } catch {}
      }
      warning=await stockFailure(error, entries, cartBefore);
      if (added) warning+=' Die Artikel liegen bereits im Warenkorb. Bitte prüfe die Menge.';
      errorMessage(warning);
    } finally {setBusy(false);if(added)await showNativeCart(warning);}
  }
  async function addToCart(mode) {
    if (busy) return;
    if (mode === 'bundle' && bundleEdit) return finishBundleEdit(true);
    if (mode === 'product' && !primaryId) return addStandaloneProduct();
    const selection = mode === 'product' ? { [primaryId]: quantity } : { ...bundle };
    let expected = quote(selection, mode);
    if (mode === 'bundle' && !canSubmit(expected)) return;
    const groupId='h'+(crypto.randomUUID ? crypto.randomUUID().replaceAll('-','') : Date.now().toString(36)+Math.random().toString(36).slice(2));
    const properties=groupProperties(groupId,mode);
    errorMessage(''); setBusy(true);
    let added=false, warning='', cartBefore;
    const entries = selectedStockEntries(selection);
    try {
      cartBefore = await readCart();
      if (stockGuard) await stockGuard.assertAvailable(entries, cartBefore);
      expected = quote(selection, mode);
      const items=Object.entries(selection).filter(([,count])=>count>0).map(([id,count])=>({id:products[id].variantId,quantity:count,properties}));
      await cartRequest('cart/add.js',{items}); added=true;
      const state=await refreshCartDiscounts();
      warning=verifyGroup(state,groupId,selection,expected);
      if ($('#bundle-builder').open) $('#bundle-builder').close();
      announce('Deine Auswahl wurde zum Warenkorb hinzugefügt.');
    } catch(error) {
      try { added=groupItems(await readCart(),groupId).length>0; } catch {}
      warning=await stockFailure(error, entries, cartBefore);
      if (added) { warning+=' Die Artikel liegen bereits im Warenkorb. Bitte prüfe die Preise.'; $('#bundle-builder').close(); }
      errorMessage(warning);
    } finally {
      setBusy(false);
      if (added) await showNativeCart(warning);
    }
  }
  function selectRoutine(name, focus = false) {
    if (!Object.hasOwn(routines, name)) return;
    $$('.routine-tabs button').forEach(button => {
      const selected = button.dataset.routine === name;
      button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1;
      if (selected && focus) button.focus();
    });
    $('#routine-panel').setAttribute('aria-labelledby', `tab-${name}`);
    const paragraphs = routines[name].split(/\n+/).map(text=>text.trim()).filter(Boolean);
    $('#routine-panel').innerHTML = `<ol>${paragraphs.map((text,i)=>`<li><span>${String(i+1).padStart(2,'0')}</span><div><p>${html(text)}</p></div></li>`).join('')}</ol>`;
  }
  $$('input[name=quantity]').forEach(input => input.addEventListener('change', () => setQuantity(Number(input.value))));
  $$('.thumbnail').forEach(button => button.addEventListener('click', () => selectImage(Number(button.dataset.image))));
  $('.zoom-button').addEventListener('click', () => showDialog($('.lightbox')));
  $('#previous-image').addEventListener('click', () => selectImage(galleryIndex - 1));
  $('#next-image').addEventListener('click', () => selectImage(galleryIndex + 1));
  $('.lightbox').addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); selectImage(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1)); } });
  $$('.close-dialog').forEach(button => button.addEventListener('click', () => closeDialog(button.closest('dialog'))));
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
  }));
  $$('.add-product').forEach(button => button.addEventListener('click', () => addToCart('product')));
  $('#add-bundle').addEventListener('click', () => addToCart('bundle'));
  $$('.builder-add').forEach(button => button.addEventListener('click', () => addToCart('bundle')));
  $$('.open-builder').forEach(button => button.addEventListener('click', () => openBuilder({ source: button.classList.contains('edit-bundle') ? 'resume' : 'product' })));
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href, location.href);
    if (target.origin === location.origin && target.pathname === location.pathname && ['#bundle', '#bundle-empty'].includes(target.hash)) {
      event.preventDefault(); openBuilder({ source: target.hash === '#bundle-empty' ? 'menu' : 'product' });
    }
  });
  $('#catalog-search').addEventListener('input', applyCatalogFilters);
  $('#catalog-sort').addEventListener('change', applyCatalogFilters);
  $('#catalog-available').addEventListener('change', applyCatalogFilters);
  $('#reset-catalog').addEventListener('click', () => { $('#catalog-search').value = ''; $('#catalog-available').checked = false; catalogCategory = 'all'; $('#catalog-sort').value = 'default'; applyCatalogFilters(); $('#catalog-search').focus(); });
  for (const container of [$('#catalog-grid'), $('#builder-selected')]) container.addEventListener('click', event => {
    const button = event.target.closest('button[data-action]');
    if (!button || button.disabled || !container.contains(button)) return;
    const id = button.dataset.productId, action = button.dataset.action;
    setBundleQuantity(id, action === 'remove' ? 0 : bundle[id] + (action === 'plus' ? 1 : -1));
  });
  $('#toggle-builder-summary').addEventListener('click', () => toggleBuilderSummary());
  $('.summary-close').addEventListener('click', () => { toggleBuilderSummary(false); $('#toggle-builder-summary').focus(); });
  $('#cancel-bundle-edit').addEventListener('click', () => finishBundleEdit(false));
  $('#bundle-builder').addEventListener('cancel', event => { if (busy) { event.preventDefault(); return; } if (bundleEdit) { event.preventDefault(); finishBundleEdit(false); } });
  $('#bundle-builder').addEventListener('close', () => { toggleBuilderSummary(false); if (bundleEdit) finishBundleEdit(false); });
  window.matchMedia('(max-width:760px)').addEventListener('change', () => toggleBuilderSummary($('#bundle-builder').classList.contains('summary-open')));
  $$('.routine-tabs button').forEach(button => {
    button.addEventListener('click', () => selectRoutine(button.dataset.routine));
    button.addEventListener('keydown', event => {
      const names = Object.keys(routines); let index = names.indexOf(button.dataset.routine);
      if (event.key === 'ArrowRight') index = (index + 1) % names.length;
      else if (event.key === 'ArrowLeft') index = (index + names.length - 1) % names.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = names.length-1;
      else return;
      event.preventDefault(); selectRoutine(names[index], true);
    });
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      $('.sticky-purchase').hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top >= 0;
    }, { threshold: 0 }).observe($('.set-invitation'));
  }

  syncSetLinks();
  createBundleCards(); createCatalog(); renderBundle();
  renderPrimary();selectRoutine('use');
  $('#hebeso-design-variant')?.addEventListener('change',event=>{
    if(busy)return;
    primary=config.variants.find(item=>String(item.variantId)===event.target.value);
    primaryId=Object.keys(products).find(id=>products[id].variantId===primary.variantId);
    quantity=1;errorMessage('');renderPrimary();
    if(primary.image){const index=gallery.findIndex(image=>image.source===primary.image);if(index>=0)selectImage(index);}
    const url=new URL(location.href);url.searchParams.set('variant',primary.variantId);history.replaceState(history.state,'',url.href);
  });
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-hebeso-edit-set]');
    if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); editCartBundle(link.dataset.hebesoEditSet);
  });
  function renderCartContext() {
    if (busy) return;
    serverCart = pricing.getCart();
    renderBundle();
    renderPrimary();
  }
  document.addEventListener('hebeso:pricing-updated', renderCartContext);
  async function syncCartContext() {
    if (busy || document.hidden) return;
    try { await readCart(); renderCartContext(); }
    catch { $('[data-hebeso-price-context]').textContent = pricing.strings.context_unknown; }
  }
  window.addEventListener('pageshow', syncCartContext);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) syncCartContext(); });
  syncCartContext();
  const editSet=new URL(location.href).searchParams.get('edit_set');
  if(editSet) {
    const cleanUrl=new URL(location.href); cleanUrl.searchParams.delete('edit_set');
    history.replaceState(history.state,'',cleanUrl.href);
    editCartBundle(editSet);
  } else if (['#bundle', '#bundle-empty'].includes(location.hash)) {
    openBuilder({ source: location.hash === '#bundle-empty' ? 'menu' : 'product' });
  }
  window.addEventListener('hashchange', () => {
    if (['#bundle', '#bundle-empty'].includes(location.hash) && !busy) {
      openBuilder({ source: location.hash === '#bundle-empty' ? 'menu' : 'product' });
    }
  });
})();



